// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Belt_Result from "rescript/lib/es6/belt_Result.js";
import * as GraphqlTag from "graphql-tag";
import * as SpaceX$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/SpaceX.res.mjs";
import * as QueryHook2$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/QueryHook2.res.mjs";
import * as LocaleContext$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/LocaleContext.res.mjs";
import * as AcademyFragments$LiteracyplanetClientSxEntry from "./AcademyFragments.res.mjs";

var Raw = {};

var query = GraphqlTag.gql([
      "query AcademyActivitiesQuery($id: ID!, $yearLevel: LearningLevelEnum!, $locale: Locale!)  {\nfindActivitiesByParentId(id: $id, locale: $locale)  {\n...ActivityFragment   \n}\n\nfindBreadCrumb(id: $id, locale: $locale)  {\n...MenuFragment   \n}\n\nfindStrandsByLevel(level: $yearLevel, locale: $locale)  {\n...MenuFragment   \n}\n\n}\n",
      "",
      ""
    ], AcademyFragments$LiteracyplanetClientSxEntry.MenuFragment.query, AcademyFragments$LiteracyplanetClientSxEntry.ActivityFragment.query);

function parse(value) {
  var value$1 = value.findActivitiesByParentId;
  var value$2 = value.findBreadCrumb;
  var value$3 = value.findStrandsByLevel;
  return {
          findActivitiesByParentId: value$1.map(function (value) {
                return AcademyFragments$LiteracyplanetClientSxEntry.ActivityFragment.verifyArgsAndParse("ActivityFragment", value);
              }),
          findBreadCrumb: value$2.map(function (value) {
                return AcademyFragments$LiteracyplanetClientSxEntry.MenuFragment.verifyArgsAndParse("MenuFragment", value);
              }),
          findStrandsByLevel: value$3.map(function (value) {
                return AcademyFragments$LiteracyplanetClientSxEntry.MenuFragment.verifyArgsAndParse("MenuFragment", value);
              })
        };
}

function serialize(value) {
  var value$1 = value.findStrandsByLevel;
  var findStrandsByLevel = value$1.map(function (value) {
        return AcademyFragments$LiteracyplanetClientSxEntry.MenuFragment.serialize(value);
      });
  var value$2 = value.findBreadCrumb;
  var findBreadCrumb = value$2.map(function (value) {
        return AcademyFragments$LiteracyplanetClientSxEntry.MenuFragment.serialize(value);
      });
  var value$3 = value.findActivitiesByParentId;
  var findActivitiesByParentId = value$3.map(function (value) {
        return AcademyFragments$LiteracyplanetClientSxEntry.ActivityFragment.serialize(value);
      });
  return {
          findActivitiesByParentId: findActivitiesByParentId,
          findBreadCrumb: findBreadCrumb,
          findStrandsByLevel: findStrandsByLevel
        };
}

function serializeVariables(inp) {
  var a = inp.yearLevel;
  var a$1 = inp.locale;
  return {
          id: inp.id,
          yearLevel: a === "LEVEL_10" ? "LEVEL_10" : (
              a === "LEVEL_11" ? "LEVEL_11" : (
                  a === "LEVEL_12" ? "LEVEL_12" : (
                      a === "PRE" ? "PRE" : (
                          a === "LEVEL_0" ? "LEVEL_0" : (
                              a === "LEVEL_1" ? "LEVEL_1" : (
                                  a === "LEVEL_2" ? "LEVEL_2" : (
                                      a === "LEVEL_3" ? "LEVEL_3" : (
                                          a === "LEVEL_4" ? "LEVEL_4" : (
                                              a === "LEVEL_5" ? "LEVEL_5" : (
                                                  a === "LEVEL_6" ? "LEVEL_6" : (
                                                      a === "LEVEL_7" ? "LEVEL_7" : (
                                                          a === "LEVEL_8" ? "LEVEL_8" : (
                                                              a === "LEVEL_9" ? "LEVEL_9" : "UNKNOWN"
                                                            )
                                                        )
                                                    )
                                                )
                                            )
                                        )
                                    )
                                )
                            )
                        )
                    )
                )
            ),
          locale: a$1 === "en_BZ" ? "en_BZ" : (
              a$1 === "en_CA" ? "en_CA" : (
                  a$1 === "en_CB" ? "en_CB" : (
                      a$1 === "en_GB" ? "en_GB" : (
                          a$1 === "en_IE" ? "en_IE" : (
                              a$1 === "en_IN" ? "en_IN" : (
                                  a$1 === "en_JM" ? "en_JM" : (
                                      a$1 === "en_NZ" ? "en_NZ" : (
                                          a$1 === "en_PH" ? "en_PH" : (
                                              a$1 === "en_TT" ? "en_TT" : (
                                                  a$1 === "en_US" ? "en_US" : (
                                                      a$1 === "en_ZA" ? "en_ZA" : (
                                                          a$1 === "en_ZW" ? "en_ZW" : "en_AU"
                                                        )
                                                    )
                                                )
                                            )
                                        )
                                    )
                                )
                            )
                        )
                    )
                )
            )
        };
}

function makeVariables(id, yearLevel, locale, param) {
  return {
          id: id,
          yearLevel: yearLevel,
          locale: locale
        };
}

var Query_inner = {
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  makeVariables: makeVariables
};

var include = SpaceX$LiteracyplanetClientFlags.Query.Extend({
      query: query,
      Raw: Raw,
      parse: parse,
      serialize: serialize,
      serializeVariables: serializeVariables
    });

var use = include.use;

var useFetch = include.useFetch;

var Query = {
  Query_inner: Query_inner,
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  makeVariables: makeVariables,
  use: use,
  useFetch: useFetch
};

var Q = QueryHook2$LiteracyplanetClientFlags.Make({
      Raw: Raw,
      use: use,
      useFetch: useFetch
    });

function onLoading(param) {
  return "LoadingAcademyActivities";
}

function partition(m) {
  return Belt_Array.reduce(m, [
                [
                  [],
                  []
                ],
                0
              ], (function (param, curr) {
                  var i = param[1];
                  var a = param[0];
                  var i$1 = i === 1 ? 0 : i + 1 | 0;
                  var arr = a[i$1];
                  var newArr = Belt_Array.concat(arr, [curr]);
                  a[i$1] = newArr;
                  return [
                          a,
                          i$1
                        ];
                }))[0];
}

function handleResponse(res) {
  return {
          TAG: "AcademyActivities",
          _0: {
            strands: res.findStrandsByLevel,
            activities: partition(res.findActivitiesByParentId),
            breadcrumb: res.findBreadCrumb
          }
        };
}

function onResult(query) {
  return Belt_Result.map(query, handleResponse);
}

function use$1(id, yearLevel) {
  var api = LocaleContext$LiteracyplanetClientFlags.use();
  var locale = api.locale;
  return Curry._4(Q.useWithErrorModal, onLoading, onLoading, onResult, {
              id: id,
              yearLevel: yearLevel,
              locale: locale
            });
}

var MenuFragment;

var ActivityFragment;

export {
  MenuFragment ,
  ActivityFragment ,
  Query ,
  Q ,
  onLoading ,
  partition ,
  handleResponse ,
  onResult ,
  use$1 as use,
}
/* query Not a pure module */
